/** Supabase learner table names (stud_/inst_/core_ prefixes in DB). */
export const LEARNER_TABLES = {
  studentProfiles: 'stud_profiles',
  userJourneyState: 'stud_journey_state',
  userTopicProgress: 'stud_topic_progress',
  userHighlights: 'stud_highlights',
  userBookmarks: 'stud_bookmarks',
  userLearningGoals: 'stud_learning_goals',
  userDailyStudy: 'stud_daily_study',
  userRecentTopics: 'stud_recent_topics',
  pageComments: 'stud_page_comments',
  pageRatings: 'stud_page_ratings',
  pageClapCounts: 'stud_page_clap_counts',
  pageClapStats: 'stud_page_clap_stats',
  pageClapEvents: 'stud_page_clap_events',
  pageUserClaps: 'stud_page_user_claps',
  userLearningConsent: 'stud_learning_consent',
  userQuizAttempts: 'stud_quiz_attempts',
  userSadhanaRoutine: 'stud_sadhana_routine',
  contactMessages: 'stud_contact_messages',
  topicReleases: 'inst_topic_releases',
  admins: 'core_admins',
  disabledUsers: 'inst_disabled_users',
  lessonDiscussions: 'stud_lesson_discussions',
  lessonDiscussionUserClaps: 'stud_lesson_discussion_user_claps',
  lessonDiscussionClapStats: 'stud_lesson_discussion_clap_stats',
  lessonDiscussionClapCounts: 'stud_lesson_discussion_clap_counts',
  lessonDiscussionPageStats: 'stud_lesson_discussion_page_stats',
  lessonDiscussionEvents: 'stud_lesson_discussion_events',
  bhriguQuestions: 'stud_bhrigu_questions',
  bhriguUserQuota: 'stud_bhrigu_quota',
  pageChatSessions: 'stud_page_chat_sessions',
  pageChatMessages: 'stud_page_chat_messages',
  bhriguModerationStrikes: 'stud_bhrigu_strikes',
};
